module.exports = __webpack_public_path__ + "static/media/home_fire.6e562c19.png";